import {
    Button,
    Checkbox,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import {useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {ItemPaper} from "./WeaponBuilder";
import {generateLoadoutId} from "./share/LoadoutDisplayMenu";


function MultiWeapons({
                          selectedWeapon,
                          selectedAttachments,
                          setSelectedWeapon,
                          setSelectedAttachments,
                          savedLoadouts,
                          setSavedLoadouts,
                          shownOnGraph,
                          setShownOnGraph,
                          selectedLoadout,
                          setSelectedLoadout
                      }) {

    const [nameInput, setNameInputState] = useState("")
    const [inputError, setInputError] = useState(false)

    const setNameInput = (name) => {
        name = name.replace(/[^\w\sà-üÀ-Ü\-._!]+/g, '').substring(0, 20)
        setNameInputState(name)
    }

    const isShownOnGraph = (w) => shownOnGraph.find((shown) => shown.name === w.name) != null

    const saveWeapon = () => {
        if (selectedWeapon == null || savedLoadouts.length > 49 || nameInput.trim().length < 1) {
            setInputError(true)
            return
        }
        let newLoadout = selectedLoadout?.name === nameInput.trim() ?
            {
                ...selectedLoadout,
                attachments: selectedAttachments,
                loadoutId: generateLoadoutId(selectedWeapon, selectedAttachments)
            }
            :
            {
                weapon: selectedWeapon,
                attachments: selectedAttachments,
                name: nameInput.trim(),
                id: crypto.randomUUID(),
                loadoutId: generateLoadoutId(selectedWeapon, selectedAttachments)
            }
        const newSavedLoadouts = savedLoadouts.filter(savedLoadout => savedLoadout.name !== newLoadout.name || savedLoadout.id !== newLoadout.id)
        newSavedLoadouts.push(newLoadout)
        setSavedLoadouts(newSavedLoadouts)
        setSelectedLoadout(newLoadout)
        setNameInput("")
    }

    function deleteWeapon(loadout) {
        const i = savedLoadouts.findIndex(l => l.id === loadout.id)
        savedLoadouts.splice(i, 1)
        setSavedLoadouts([...savedLoadouts])
        setSelectedLoadout(null)
    }

    const toggleFromGraph = (weapon) => {
        if (isShownOnGraph(weapon)) {
            setShownOnGraph(shownOnGraph.filter((element) => element.name !== weapon.name))
        } else {
            if (shownOnGraph.length < 5) setShownOnGraph([...shownOnGraph, weapon])
        }
    };

    return (
        <ItemPaper sx={{height: '30vh'}}>
            <Stack sx={{height: '100%'}}>
                <Typography fontSize='1.25rem'>Saved Weapons</Typography>
                <Typography fontSize='0.7rem' fontStyle='oblique'>Select up to 5 weapons to compare on
                    graph</Typography>
                {
                    <List dense
                          sx={{
                              width: '100%',
                              maxWidth: 360,
                              flexGrow: 1,
                              overflow: 'auto',
                          }}
                    >
                        {
                            Object.values(savedLoadouts).map(l => {
                                    return <ListItemButton
                                        key={`saved-loadout-${l.id}`}
                                        onClick={(e) => {
                                            if (e.target.checked == null) {
                                                setSelectedWeapon(l.weapon);
                                                setSelectedAttachments(l.attachments)
                                                setSelectedLoadout(l)
                                                setNameInput(l.name)
                                            }
                                        }}
                                        sx={{padding: '5px'}}
                                    >
                                        <ListItem sx={{padding: 0}} secondaryAction={
                                            <IconButton edge="end" aria-label="delete" onClick={() => deleteWeapon(l)}>
                                                <DeleteIcon sx={{color: 'text.secondary'}}/>
                                            </IconButton>
                                        }
                                        >
                                            <Checkbox checked={isShownOnGraph(l)}
                                                      sx={{color: 'white'}}
                                                      onChange={() => toggleFromGraph(l)}/>
                                            <ListItemText primary={l.name} secondary={l.weapon.name}/>
                                        </ListItem>
                                    </ListItemButton>;
                                }
                            )
                        }
                    </List>
                }
                <TextField id="userWeaponName" label="Custom Name" variant="outlined" value={nameInput}
                           onChange={(e) => {
                               setNameInput(e.target.value);
                               setInputError(false)
                           }}
                           sx={{
                               marginTop: '8px',
                               '& label.Mui-focused': {
                                   color: 'white',
                               },
                               '& .MuiOutlinedInput-root': {
                                   '&.Mui-focused fieldset': {
                                       borderColor: 'white'
                                   }
                               }
                           }} error={inputError}/>
                <Button variant="contained" onClick={saveWeapon}>Save Weapon</Button>
            </Stack>
        </ItemPaper>
    )
}

export default MultiWeapons;
